import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import entity from './modules/entites'
import agency from './modules/agences'
import atm from './modules/guichets'
import commission from './modules/commissions'
import tarification from './modules/tarifications'
import grilletarifaire from './modules/grilletarifaires'
import typepiece from './modules/typedepieces'
import user from './modules/users'
import role from './modules/roles'
import mandate from './modules/mandats'
import typeoperation from './modules/typeoperations'
import typeoperation_headers from './modules/typeoperations_headers'
import appro from './modules/approvisionnements'
import planning from './modules/plannings'
import etat from './modules/etat'
import charts from './modules/charts'
import plafonds from './modules/plafonds'
import mouchards from './modules/mouchards'
import histories from './modules/histories'
//import createLogger from '../../../src/plugins/logger'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const ERROR_MSG = ''

export const store = new Vuex.Store({
  modules: {
    auth,
    entity,
    agency,
    atm,
    commission,
    tarification,
    typepiece,
    user,
    mandate,
    typeoperation,
    typeoperation_headers,
    grilletarifaire,
    appro,
    role,
    etat,
    charts,
    planning,
    plafonds,
    mouchards,
    histories
  },
  strict: debug,
})
